import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ContentBlockIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M6.16699 2.66699C6.16699 2.57494 6.09205 2.5 6 2.5H2.66699C2.57494 2.5 2.5 2.57494 2.5 2.66699V6C2.5 6.09205 2.57494 6.16699 2.66699 6.16699H6C6.09205 6.16699 6.16699 6.09205 6.16699 6V2.66699ZM7.16699 6C7.16699 6.64433 6.64433 7.16699 6 7.16699H2.66699C2.02266 7.16699 1.5 6.64433 1.5 6V2.66699C1.5 2.02266 2.02266 1.5 2.66699 1.5H6C6.64433 1.5 7.16699 2.02266 7.16699 2.66699V6Z"
      fill="currentColor"
    />
    <path
      d="M14.0003 2.16666C14.2763 2.16683 14.5003 2.39062 14.5003 2.66666C14.5003 2.94269 14.2763 3.16648 14.0003 3.16666H9.33334C9.0572 3.16666 8.83334 2.9428 8.83334 2.66666C8.83334 2.39051 9.0572 2.16666 9.33334 2.16666H14.0003Z"
      fill="currentColor"
    />
    <path
      d="M14.0003 5.5C14.2763 5.50018 14.5003 5.72397 14.5003 6C14.5003 6.27603 14.2763 6.49982 14.0003 6.5H9.33334C9.0572 6.5 8.83334 6.27614 8.83334 6C8.83334 5.72386 9.0572 5.5 9.33334 5.5H14.0003Z"
      fill="currentColor"
    />
    <path
      d="M14 9.5C14.2761 9.5 14.5 9.72386 14.5 10C14.5 10.2761 14.2761 10.5 14 10.5L2 10.5C1.72386 10.5 1.5 10.2761 1.5 10C1.5 9.72386 1.72386 9.5 2 9.5L14 9.5Z"
      fill="currentColor"
    />
    <path
      d="M14 13.5C14.2761 13.5 14.5 13.7239 14.5 14C14.5 14.2761 14.2761 14.5 14 14.5L2 14.5C1.72386 14.5 1.5 14.2761 1.5 14C1.5 13.7239 1.72386 13.5 2 13.5L14 13.5Z"
      fill="currentColor"
    />
  </svg>
);
